module.exports = window["MaterialUI"].Badge;